export default {"src":"/_next/static/media/linkedin.c7130d25.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};